document.addEventListener("DOMContentLoaded", function() {

    let topN = 6;
    let sectorIds = [1,2,3,4,5,6,7,8,9,10,11];

    let primeAction = 'topdollar';
    try {
        const cachedChartType = typeof getCacheItem !== 'undefined' ? getCacheItem('lastChartType') : null;
        if (cachedChartType && cachedChartType.includes(':')) {
            primeAction = cachedChartType.split(':')[0] || 'topdollar';
        }

        const cached = typeof getCacheItem !== 'undefined' ? getCacheItem(`segments_state_${primeAction}`) : null;
        if (cached) {
            const state = JSON.parse(cached);
            if (state.activeSectorIDs) sectorIds = state.activeSectorIDs;
            if (state.sectorsDepth) topN = state.sectorsDepth;
        }
    } catch(e) {}

    const segmentsList = [
        { id: 1, name: 'Utilities', iconName: 'Utilities.svg', color: '#00C4B3', isActive: sectorIds.includes(1) },
        { id: 2, name: 'Energy', iconName: 'Energy.svg', color: '#ACACAC', isActive: sectorIds.includes(2) },
        { id: 3, name: 'Materials', iconName: 'Materials.svg', color: '#697AB6', isActive: sectorIds.includes(3) },
        { id: 4, name: 'Financials', iconName: 'Financials.svg', color: '#C8C8C8', isActive: sectorIds.includes(4) },
        { id: 5, name: 'Health Care', iconName: 'Health-Care.svg', color: '#E54360', isActive: sectorIds.includes(5) },
        { id: 6, name: 'Real Estate', iconName: 'Materials.svg', color: '#CAD1EA', isActive: sectorIds.includes(6) },
        { id: 7, name: 'Information-Technology', iconName: 'Information-Technology.svg', color: '#00945E', isActive: sectorIds.includes(7) },
        { id: 8, name: 'Industrials', iconName: 'Industrials.svg', color: '#3636E3', isActive: sectorIds.includes(8) },
        { id: 9, name: 'Communication Services', iconName: 'Communication-Services.svg', color: '#697AB6', isActive: sectorIds.includes(9) },
        { id: 10, name: 'Consumer Staples', iconName: 'Consumer-Staples.svg', color: '#6993DE', isActive: sectorIds.includes(10) },
        { id: 11, name: 'Consumer Discretionary', iconName: 'Customer-Discretionary.svg', color: '#FFC629', isActive: sectorIds.includes(11) },
    ];

    const segmentsContainer = document.querySelector('#sectors-assets-pop-up .content');
    if (!segmentsContainer) {
        console.warn('[segments-control] segmentsContainer not found, skipping initialization');
        return;
    }
    segmentsContainer.innerHTML = '';

    segmentsList.forEach((segment, index) => {
        const leftSide = `
                <div class="left-side">
                    <div class="dot" style="background: ${segment.color}"></div>
                    <div class="icon-wrapper"><img src="./desktop_assets/pop-up/sectors/${segment.iconName}" alt=""></div>
                    <p>${segment.name}</p>
                </div>
        `
        const rightSide = `
                <div class="checkbox-container">
                   <img src="./desktop_assets/pop-up/checkbox-active.svg" alt="" class="active-stage">
                   <img src="./desktop_assets/pop-up/checkbox-inactive.svg" alt="" class="inactive-stage">
               </div>       
        `
        segmentsContainer.innerHTML += `<div class="item ${segment.isActive ? 'active' : ''}" data-id="${segment.id}">${leftSide}${rightSide}</div>`
    })

    const segmentsItems = document.querySelectorAll('#sectors-assets-pop-up .item');
    segmentsItems.forEach(item => {
        item.addEventListener('click', () => {
            item.classList.toggle('active');

            sectorIds = [];
            segmentsItems.forEach(elem => {
                if (elem.classList.contains('active')) {
                    const id = parseInt(elem.dataset.id);
                    if (!sectorIds.includes(id)) {
                        sectorIds.push(id);
                    }
                }
            })

            applySectorsAndDepthToCube();
        })
    })

    const categoryButtons = document.querySelectorAll('#main-block .filters-container .item');
    categoryButtons.forEach(button => {
        button.addEventListener('click', () => {
            categoryButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active')

            const action = button.dataset.action;
            console.log('action', action)

            let centerContent = document.getElementById('large-center-panel-content');
            if (centerContent) {
                centerContent.replaceChildren();
                centerContent.setAttribute('position', '0 0 0');
            }

            switch (action) {
                case 'topdollar':   addStockTopDollarCubeToCenterPanel('top-dollar-vol');           break;
                case 'topdolsec':   addStockTopDollarSectorCubeToCenterPanel('top-dollar-vol-sec'); break;
                case 'topvol':      addStockByVolRankCubeToCenterPanel('top-vol');                  break;
                case 'topvolsec':    addStockByVolCubeToCenterPanel('top-vol-sec');                 break;
                case 'losers':      addStockLosersToCenterPanel();                                  break;
                case 'loserssec':   addStockLosersSectorToCenterPanel();                            break;
                case 'gainers':     addStockGainersToCenterPanel();                                 break;
                case 'gainerssec':  addStockGainersSectorToCenterPanel();                           break;
                case 'myportfolio-price':   addMyPortfolioPriceCubeToCenterPanel();                 break;
            }

            const segmentsAssetsButton = document.querySelector('#main-block .open-pop-up-segments-assets');
            if (['gainerssec','loserssec', 'topdolsec', 'topvolsec'].includes(action)) {
                segmentsAssetsButton.classList.add('show')
            } else {
                segmentsAssetsButton.classList.remove('show')
            }

        })
    })

    const depthUp = document.querySelector('#sectors-assets-pop-up .depth-up');
    const depthDown = document.querySelector('#sectors-assets-pop-up .depth-down');
    const depthInput = document.querySelector('#sectors-assets-pop-up .sector-depth input');
    const maxDepth = 10;
    const minDepth = 1;
    depthDown.addEventListener('click', () => {
        let currentDepth = parseInt(depthInput.value);
        if (currentDepth > minDepth) {
            depthInput.setAttribute('value', String(currentDepth - 1))
            topN = parseInt(depthInput.value);
            applySectorsAndDepthToCube();
        }
    })
    depthUp.addEventListener('click', () => {
        let currentDepth = parseInt(depthInput.value);
        if (currentDepth < maxDepth) {
            depthInput.setAttribute('value', currentDepth + 1)
            topN = parseInt(depthInput.value);
            applySectorsAndDepthToCube();
        }
    })

    function applySectorsAndDepthToCube() {
        const stock3dCube = document.querySelector('a-scene#main-scene #stock-3d-cube');
        if (stock3dCube) {
            stock3dCube.setAttribute('stock-cube-visualizer', {
                sectorIds,
                topN
            });
        }
    }

    const sectorsBreaksContainer = document.querySelector('#sectors-assets-pop-up .sectors-breaks-container')
    sectorsBreaksContainer.addEventListener('click', () => {
        sectorsBreaksContainer.classList.toggle('active');

        const isActive = sectorsBreaksContainer.classList.contains('active');
        const primeTypeButton = document.querySelector('#chart-type-control')
        if (primeTypeButton) {
            primeTypeButton.emit('change-secondary-action', { isActive: isActive });
        } else {
            console.warn('Element #chart-type-control not found');
        }

        const popupContainer = document.querySelector('#sectors-assets-pop-up');
        const popupBg = document.querySelector('#sectors-assets-pop-up a-rounded-plane');
        const depthContainer = document.querySelector('#sectors-assets-pop-up .sector-depth');
        const contentContainer = document.querySelector('#sectors-assets-pop-up .content');
        if (isActive) {
            depthContainer.classList.remove('disabled');
            contentContainer.classList.remove('disabled');

            // popupBg.setAttribute('height', '0.38');

            popupBg.setAttribute('animation__height', {
                property: 'height',
                to: 0.38,
                dur: 200,
                easing: 'linear'
            });
        } else {
            depthContainer.classList.add('disabled');
            contentContainer.classList.add('disabled');
            // popupBg.setAttribute('height', '0.05');
            setTimeout(() => {
                popupBg.setAttribute('animation__height', {
                    property: 'height',
                    to: 0.05,
                    dur: 200,
                    easing: 'linear'
                });
            }, 200)
        }
    })

})
